// @flow
import React, { useCallback, useEffect } from "react";
import { connect } from "react-redux";

import { Translate, withI18n } from "@quantum/i18n";

import classNames from "classnames";

import { compose } from "ramda";

import Moment from "moment";

import SelectInput from "../../../comum/SelectInput";
import {
  getIdiomaUsuario,
  getDatasBaseDeflatorPorValorBaseSelecionado,
  selecionarDataBaseDeflator,
  getDataBaseDeflatorSelecionado,
  getDeflatorSelecionado,
  getDataBaseDefault,
  getDiasUteis,
  getDataBaseDeflatorEspecificaSelecionada,
  selecionarDataBaseDeflatorDataEspecifica,
  type ActionCreator,
} from "../../../../state";
import {
  type EnumCodigoDescricao,
  FORMATO_DATA_BANCO,
  ID_DATA_BASE_DEFLATOR_DATA_ESPECIFICA,
  ID_DATA_BASE_DEFLATOR_NENHUM,
  ID_DATA_BASE_DEFLATOR_REFERENCIA,
} from "../../../../model";
import { DateCalendarPicker } from "../../../comum";

type Props = {
  listaDataBaseDeflator: Array<EnumCodigoDescricao>,
  dataBaseDeflatorSelecionada: string,
  selecionarDataBaseDeflator: ActionCreator,
  selecionarDataBaseDeflatorDataEspecifica: ActionCreator,
  deflatorSelecionado: string,
  diasUteis: Array<string>,
  dataBaseDefault: string,
  dataEspecificaSelecionada: ?Moment,
  exibirSelecaoDataEspecifica: boolean,
  idiomaUsuario: string,
  forcarExibirNormalizacao?: boolean,
  exibirOpcaoNenhum?: boolean,
};

function SelecaoDataBaseDeflacao({
  listaDataBaseDeflator,
  dataBaseDeflatorSelecionada,
  selecionarDataBaseDeflator,
  selecionarDataBaseDeflatorDataEspecifica,
  deflatorSelecionado,
  diasUteis,
  dataBaseDefault,
  dataEspecificaSelecionada,
  exibirSelecaoDataEspecifica,
  idiomaUsuario,
  forcarExibirNormalizacao = false,
  exibirOpcaoNenhum = false,
}: Props) {
  useEffect(() => {
    if (dataBaseDeflatorSelecionada === null) {
      selecionarDataBaseDeflator(
        exibirOpcaoNenhum
          ? ID_DATA_BASE_DEFLATOR_NENHUM
          : ID_DATA_BASE_DEFLATOR_REFERENCIA
      );
    }
  }, [
    dataBaseDeflatorSelecionada,
    exibirOpcaoNenhum,
    selecionarDataBaseDeflator,
  ]);

  const onChange = useCallback(
    dataBase => {
      selecionarDataBaseDeflator(dataBase);
      if (dataBase !== ID_DATA_BASE_DEFLATOR_DATA_ESPECIFICA) {
        selecionarDataBaseDeflatorDataEspecifica(null);
      }
    },
    [selecionarDataBaseDeflator, selecionarDataBaseDeflatorDataEspecifica]
  );

  const isValidDate = useCallback(
    dataASerValidada => {
      const data = Moment(dataASerValidada, "DD/MM/YYYY", true);
      return (
        data.isSameOrAfter(Moment("19970101", FORMATO_DATA_BANCO)) &&
        data.isSameOrBefore(Moment(dataBaseDefault, FORMATO_DATA_BANCO)) &&
        diasUteis.includes(data.format(FORMATO_DATA_BANCO))
      );
    },
    [dataBaseDefault, diasUteis]
  );

  if (!forcarExibirNormalizacao && !deflatorSelecionado) {
    return null;
  }

  const selecaoDataEspecifica = exibirSelecaoDataEspecifica ? (
    <DateCalendarPicker
      className="ConfiguracaoMedida__input-data"
      label={""}
      value={dataEspecificaSelecionada}
      onChange={selecionarDataBaseDeflatorDataEspecifica}
      closeOnSelect={true}
      strictParsing={true}
      isValidDate={isValidDate}
      locale={idiomaUsuario}
    />
  ) : null;

  return (
    <div className="ConfiguracaoMedida">
      <label className="ConfiguracaoMedida__label">
        <Translate>ConfiguracaoIndicador.DataBase</Translate>
      </label>
      <SelectInput
        className={classNames(
          "ConfiguracaoMedida__input-select",
          "ConfiguracaoMedida__DataBase"
        )}
        options={listaDataBaseDeflator}
        value={dataBaseDeflatorSelecionada}
        onChange={onChange}
        size={1}
        multiple={false}
        campoDescricao="traducao"
        campoId="codigo"
      />
      {selecaoDataEspecifica}
    </div>
  );
}

export default compose(
  withI18n,
  connect(
    (state, ownProps) => ({
      listaDataBaseDeflator: getDatasBaseDeflatorPorValorBaseSelecionado(state)
        .filter(
          datasBaseDeflator =>
            ownProps.exibirOpcaoNenhum === true ||
            datasBaseDeflator.codigo !== ID_DATA_BASE_DEFLATOR_NENHUM
        )
        .map(dataBase => ({
          ...dataBase,
          traducao: ownProps.translate(dataBase.descricao),
        })),
      diasUteis: getDiasUteis(state),
      dataBaseDeflatorSelecionada: getDataBaseDeflatorSelecionado(state),
      deflatorSelecionado: getDeflatorSelecionado(state),
      dataBaseDefault: getDataBaseDefault(state),
      dataEspecificaSelecionada: getDataBaseDeflatorEspecificaSelecionada(
        state
      ),
      exibirSelecaoDataEspecifica:
        getDataBaseDeflatorSelecionado(state) ===
        ID_DATA_BASE_DEFLATOR_DATA_ESPECIFICA,
      idiomaUsuario: getIdiomaUsuario(state),
    }),
    { selecionarDataBaseDeflator, selecionarDataBaseDeflatorDataEspecifica }
  )
)(SelecaoDataBaseDeflacao);
